import * as azureAuth from '@/lib/Azure/auth'

const DEFAULT_AUTHENTICATION_TYPE = 'local'
const ONE_MINUTE_IN_MILLISECONDS = 1000 * 60
const AZURE_STORAGE_PROVIDER = 'EXTERNAL_AZURE_STORAGE_SERVICE'
const TOKENS_REFRESH_INTERVAL_KEY = '__reverAzureTokensRefreshInterval__'
const AZURE_AUTHENTICATION_TYPES = [
  'local_and_azure_active_directory',
  'azure_active_directory',
]

export default function silentRefreshForActiveDirectory(context) {
  try {
    const globalScope = getGlobalScope()

    if (globalScope[TOKENS_REFRESH_INTERVAL_KEY]) {
      return
    }

    const intervalId = setInterval(() => {
      runRefreshProcess(context.store).catch(() => handleError(context))
    }, ONE_MINUTE_IN_MILLISECONDS)

    globalScope[TOKENS_REFRESH_INTERVAL_KEY] = intervalId
  } catch (error) {
    console.error(error)
  }
}

export function stopTokensRefreshingProcess() {
  const globalScope = getGlobalScope()
  const intervalId = globalScope[TOKENS_REFRESH_INTERVAL_KEY]

  if (!intervalId) return

  clearInterval(intervalId)
  globalScope[TOKENS_REFRESH_INTERVAL_KEY] = null
}

async function runRefreshProcess(store) {
  const authenticationType =
    store?.state?.access?.organization?.authenticationType ??
    DEFAULT_AUTHENTICATION_TYPE

  if (
    !AZURE_AUTHENTICATION_TYPES.includes(authenticationType) ||
    !requiresAzureStorage(store)
  ) {
    return
  }

  if (!didAnyTokenExpire(store)) return

  const newAzureSession = await azureAuth.silentlyRefreshSession()
  const newStorageSession = requiresAzureStorage(store)
    ? await azureAuth.requestStorageAuth()
    : null

  store.dispatch('refreshAzureTokens', {
    session: newAzureSession,
    storage: newStorageSession,
  })
}

function didAnyTokenExpire(store) {
  const azureSessionExpirationDate =
    store?.state?.access?.azure?.session?.expiresOn ?? null
  if (hasTokenExpired(azureSessionExpirationDate)) return true

  const storage = store?.state?.access?.azure?.storage ?? null
  if (!storage) return false

  return hasTokenExpired(storage?.expiresOn)
}

function requiresAzureStorage(store) {
  const organizationMediaProvider =
    store?.state?.access?.organization?.mediaProvider
  return organizationMediaProvider === AZURE_STORAGE_PROVIDER
}

function hasTokenExpired(expireOn) {
  return Date.now() >= expireOn
}

function handleError(context) {
  window.alert(
    context.translator(
      'error.you_have_been_logged_out_of_your_microsoft_account_please_login_again'
    )
  )

  context.router.push('/logout')
}

function getGlobalScope() {
  return globalThis
}
